
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CancelarVisitaMasivaComponent } from './cancelar-visita-masiva.component';

const routes: Routes = [
    { path: '', component: CancelarVisitaMasivaComponent }
];

@NgModule({
    imports: [RouterModule.forChild(routes), FormsModule, ReactiveFormsModule],
    exports: [RouterModule]
})
export class CancelarVisitaMasivaRoutingModule { }
